import { ReactNode } from 'react';
import styled from 'styled-components';
import { TILE_SIZE_LARGE } from '../../styles/global';
import {
	InnerBorderContainer,
	OuterBorderContainer,
} from '../styled components/BorderContainer';

const Wrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: relative;
`;

const Content = styled.div`
  background-color: ${(props) => props.theme.colors.primary};
  padding: ${TILE_SIZE_LARGE / 2}vmin;
`;

const DigitContainer = styled.div`
  width: ${TILE_SIZE_LARGE * 3}vmin;
  height: ${TILE_SIZE_LARGE * 2}vmin;
`;

const PanelContainer = styled.div`
  margin-bottom: ${TILE_SIZE_LARGE / 2}vmin;
`;

const Panel = styled.div`
  background-color: ${(props) => props.theme.colors.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${TILE_SIZE_LARGE / 3}vmin;
`;

const PanelElementContainer = styled.div`
  width: ${TILE_SIZE_LARGE * 2}vmin;
  height: ${TILE_SIZE_LARGE * 2}vmin;
`;

interface GameLayoutProps {
	tiles: ReactNode;
	bombCounter: ReactNode;
	smileButton: ReactNode;
	timer: ReactNode;
	alert: ReactNode;
}

const GameLayout = ({
						tiles,
						bombCounter,
						smileButton,
						timer,
						alert
					}: GameLayoutProps) => {
	return (
		<Wrapper>
			{alert}
			<OuterBorderContainer>
				<Content>
					<PanelContainer>
						<InnerBorderContainer>
							<Panel>
								<DigitContainer>{bombCounter}</DigitContainer>
								<PanelElementContainer>
									<OuterBorderContainer>
										{smileButton}
									</OuterBorderContainer>
								</PanelElementContainer>
								<DigitContainer>{timer}</DigitContainer>
							</Panel>
						</InnerBorderContainer>
					</PanelContainer>
					<InnerBorderContainer>{tiles}</InnerBorderContainer>
				</Content>
			</OuterBorderContainer>
		</Wrapper>
	);
};

export default GameLayout;
